import { ProcessedCustomerOrgTree, ProcessedOrgTree } from '../OrgTree';

export const useBuildRestrictionLabelFromOrgTree = (orgTree: ProcessedOrgTree[]) => {
  const selectedMsps = orgTree.filter(f => f.checked);

  const selectedCustomers = orgTree.reduce((accumulator: ProcessedCustomerOrgTree[], item) => {
    // Filter out only the checked customers for each item
    const checkedCustomers = item.customers.filter(customer => customer.checked);

    // Merge the checked customers into the accumulator array
    return accumulator.concat(checkedCustomers);
  }, []);

  if (selectedMsps.length === 0) {
    return 'Available to all customers';
  } else if (selectedCustomers.length === 1) {
    return `Available to ${selectedCustomers[0].customerName}`;
  } else {
    if (Object.keys(selectedMsps).length > 1) {
      return `Available to ${selectedCustomers.length} Customers`;
    } else {
      if (selectedMsps[0].customers.length === selectedCustomers.length) {
        return `Available to ${selectedMsps[0].mspName} Customers`;
      }

      return `Available to ${selectedCustomers.length} Customers`;
    }
  }
};
